/**
 * 号码包管理页面
 */
export default {
  dbl_number_package_title: "号码包",
  dbl_number_package_extract: "提取号码包",
  dbl_number_package_upload: "上传号码包",
  dbl_number_package_name: "包名称",
  dbl_number_package_name_placeholder: "请输入包名称",
  dbl_number_package_type: "包类型",
  dbl_number_package_static: "静态",
  dbl_number_package_dynamic: "动态",
  dbl_number_package_extracted_fields: "提取字段",
  dbl_number_package_extracted_fields_placeholder: "请选择提取字段",
  dbl_number_package_size: "包规模",
  dbl_number_package_note: "备注",
  dbl_number_package_status: "状态",
  dbl_number_package_ready: "就绪",
  dbl_number_package_abnormal: "异常",
  dbl_number_package_extracting: "提取中",
  dbl_number_package_pending: "待定",
  dbl_number_package_creation_time: "创建时间",
  dbl_number_package_creator: "创建人",
  dbl_number_package_operation: "操作",
  dbl_number_package_analyze: "分析",
  dbl_number_package_edit: "编辑",
  dbl_number_package_remarks: "包备注（选填）",
  dbl_number_package_remarks_placeholder: "请输入包备注",
  dbl_number_package_total: "共 {total} 项",
  dbl_number_package_search: "搜索包名称或备注",
  dbl_number_package_not_empty: "包名称不能为空",
  dbl_number_package_save: "保存",
  dbl_number_package_cancel: "取消",
  dbl_number_package_save_success: "保存{name}成功",

};